import templateUrl from './resourceActionDelete.html'

/**
 * Resource action: Delete component.
 *
 * Used directly or dynamically generated by {@link tmrResourceActions} directive.
 *
 * @example
 * <tmr-resource-action-delete
 *   resource="$ctrl.resource"
 *   redirect="'app.report.parcels.list'"
 *   destination="'app.report.parcels.Parcel.delete'"
 * ></tmr-resource-action-delete>
 *
 * @type {ngComponent}
 * @prop {TmrResource} resource
 * @prop {string=} redirect The route where the user will be redirected afted deletion. Defaults to current state
 * @prop {string=} destination The destination state; may be omitted if the current state is a resourceList route
 */
export const tmrResourceActionDelete = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrResourceActionDeleteController',
  bindings: {
    resource: '<',
    redirect: '<?',
    destination: '<?',
  },
}

/**
 * Controller of component {@link tmrResourceActionDelete}.
 *
 * @type {ngController}
 */
export class tmrResourceActionDeleteController {
  static ngType = 'controller'

  constructor($state) {
    'ngInject'
    Object.assign(this, { $state })
  }

  $onInit() {
    this.redirect = this.redirect ?? this.$state.current.name
  }
}
